import React from 'react';
import Highcharts from 'highcharts';
import { options } from './options';
import _ from 'lodash';

export default class LineChart extends React.Component {

  generateChart = (isFirstRender) => {
    const { chartType, chartId, data, yAxis, xAxisTitle, tooltipFormatter, onClick, disableAnimation } = this.props;
    Highcharts.setOptions(options);
    const copyChartType = Object.assign({}, chartType);
    if (!copyChartType.chart) {
      copyChartType.chart = {};
    }
    copyChartType.chart.animation = !disableAnimation;
    if (!copyChartType.plotOptions) {
      copyChartType.plotOptions = {};
    }
    if (!copyChartType.plotOptions.series) {
      copyChartType.plotOptions.series = {};
    }
    copyChartType.plotOptions.series.animation = !disableAnimation;

    // make all data points circles instead of random shapes
    _.each(data, (d) => {
      d.marker = {
        symbol: 'circle',
        enabled: true
      };
      return d;
    });

    copyChartType.series = data;
    if (yAxis) {
      copyChartType.yAxis = yAxis;
    }

    if (xAxisTitle) {
      copyChartType.xAxis.title = {
        text: xAxisTitle
      };
    } else {
      copyChartType.xAxis.title = null;
    }

    copyChartType.tooltip = {
      shared: true,
      useHTML: true
    };

    if (onClick) {
      if (!copyChartType.plotOptions.series.point) {
        copyChartType.plotOptions.series.point = {};
      }

      if (!copyChartType.plotOptions.series.point.events) {
        copyChartType.plotOptions.series.point.events = {};
      }

      copyChartType.plotOptions.series.cursor = 'pointer';
      copyChartType.plotOptions.series.point.events.click = onClick;
    }

    if (tooltipFormatter) {
      copyChartType.tooltip.formatter = function () {
        return tooltipFormatter(this);
      };
    }

    const chart = Highcharts.chart(chartId, copyChartType);
    if (isFirstRender) {
      chart.reflow();
    }
  };

  componentDidMount () {
    this.generateChart(true);
  }

  componentDidUpdate () {
    const { forceReflowBecauseOfBug } = this.props;
    this.generateChart(forceReflowBecauseOfBug);
  }

  render () {
    const { chartId, data, customChartContainerClass, customChartClass } = this.props;
    return (
      <div className={ `${!!customChartContainerClass && customChartContainerClass}` }>
        <div id={ chartId } className={ `${!!customChartClass && customChartClass}` } />
        { /* We need to use data prop somewhere in render or React won't watch it for changes. */ }
        <div key={ data ? data.length : 0 } />
      </div>
    );
  }
}
